import { Component, Mixins } from 'vue-property-decorator'
import * as ApiPath from '@/tcw/constant/ApiPath'
import BaseComponent from '@/tcw/components/BaseComponent'
import { ApiPayloadValueType, ChienShoumeiEntity } from '@/tcw/api/types'
import * as tcw from '@/tcw/utils/TcwService'
import { TCWBadDataStructureError, TCWUnexpectedError } from '@/plugins/TCWBaseError'
import { DEFAULT_UPLOAD_FILE_MAX_SIZE } from '@/tcw/constant/TcwConstant'
import { ChienShoumeiFile } from '../types'

@Component
export default class ChienshomeiMixin extends Mixins(BaseComponent) {
  protected chienShoumeiLoading = false
  protected fileList: ChienShoumeiFile[] = []
  protected deleteFileIdList: number[] = []
  protected uploadFileMaxSize = DEFAULT_UPLOAD_FILE_MAX_SIZE
  /**
   * ファイルがセットされているか
   */
  protected get hasUploadFile(): boolean {
    // アップロード対象のファイルがセットされているか
    return this.fileList.some(f => f.id === undefined) // ID未セットのデータ（=未保存）があるか
  }
  protected get uploadFiles(): File[] {
    return this.fileList.filter(f => f.id === undefined && f.raw).map(f => f.raw as File)
  }
  protected get hasDeleteFile(): boolean {
    return this.deleteFileIdList.length > 0
  }
  protected createUploadPostParams(uploadFile: File): FormData {
    // FormData を利用して File を POST する
    const formData = new FormData()
    formData.append('uploadFile', uploadFile)
    return formData
  }

  protected async fetchChienShoumei(kintaiId: ApiPayloadValueType): Promise<ChienShoumeiFile[]> {
    if (kintaiId === null) {
      return Promise.reject(new TCWBadDataStructureError('勤怠IDが指定されていません'))
    }
    const path = ApiPath.buildPath(ApiPath.Paths.Chienshomei.get, {
      kintaiId: String(kintaiId)
    })
    const entityList = await this.getWebApi().call<ChienShoumeiEntity[]>(path, 'GET')

    if (!Array.isArray(entityList)) {
      return []
    }
    const fileList: ChienShoumeiFile[] = entityList.map(entity => {
      return {
        id: entity.id,
        size: entity.size,
        name: entity.fileName,
        url: tcw.getApiUrlBase() + entity.shoumeiFilePath,
        status: undefined
      }
    }) as ChienShoumeiFile[]
    return fileList
  }
  /**
   * 遅延証明書をサーバにアップロードする
   */
  protected async uploadFile(kintaiId: string | number): Promise<void> {
    if (!this.hasUploadFile) {
      return Promise.reject(
        new TCWUnexpectedError('アップロード対象のファイルが指定されていません')
      )
    }

    // リクエスト情報の生成
    const path = ApiPath.buildPath(ApiPath.Paths.Chienshomei.post, { kintaiId })

    // ファイル１つずつアップロード TODO 一括アップロード
    for (const f of this.uploadFiles) {
      // FormData を利用して File を POST する
      const formData = this.createUploadPostParams(f)
      await this.getWebApi().postWithMultipart(path, formData)
    }
  }
  protected async deleteFile(): Promise<void> {
    if (this.deleteFileIdList.length === 0) {
      return Promise.reject(new TCWUnexpectedError('削除対象のファイルがありません'))
    }

    // ファイル１つずつファイル削除 TODO 一括削除
    for (const id of this.deleteFileIdList) {
      const path = ApiPath.buildPath(ApiPath.Paths.Chienshomei.delete, { id })
      // FormData を利用して File を POST する
      await this.getWebApi().call(path, 'DELETE')
    }
  }
  /**
   * ファイル追加イベント
   */
  protected handleAdd(file: ChienShoumeiFile, fileList: ChienShoumeiFile[]): void {
    // 追加チェック
    const checkResult = this.checkFileAdd(file)
    if (!checkResult) {
      this.$tcw.message({
        type: 'error',
        message: 'ファイルサイズが上限を超えています。'
      })
      // 追加されたファイルを除去
      fileList.splice(fileList.length - 1, 1)
    } else {
      this.fileList = (fileList as unknown) as ChienShoumeiFile[]
    }
  }
  /**
   * ファイル除去イベント
   */
  protected handleRemove(file: ChienShoumeiFile, fileList: ChienShoumeiFile[]): void {
    // 削除リストに追加
    if (file.id) {
      // 保存済みのファイルだけが削除対象
      this.deleteFileIdList.push(file.id)
    }

    // データ同期
    this.fileList = fileList
  }
  /**
   * ファイル追加時のチェック処理
   * @param file ファイル
   * @returns チェックOK： true
   */
  protected checkFileAdd(file: ChienShoumeiFile): boolean {
    // ファイルサイズチェック
    return file.size ? file.size <= this.uploadFileMaxSize : false
  }
}
